import React, { Fragment, useEffect, useState } from 'react'
import Footer from '../component/Footer'
import Header from '../component/Header'
import Productos from '../component/minicomponents/Productos'

function Tienda() {
    const [productos, setProductos] = useState([])
    const [categoria, setCategoriaseleccionada] = useState([])

    const getApi = (url) => {
        fetch("https://servicios.campus.pe/categorias.php")
            .then(response => response.json())
            .then(data => {
                setProductos(data)
            })
    }

    const seleccionar = (e, item) => {
        setCategoriaseleccionada(item);
        const itemsList = document.querySelectorAll('#lista-categorias li')

        itemsList.forEach(items => {
            items.classList.remove("active")
        })

        e.currentTarget.classList.add("active")
    }

    const eliminarCategoria = () => {
        setCategoriaseleccionada({})
        //e.currentTarget.classList.remove("active")

        const itemsList = document.querySelectorAll('#lista-categorias li')

        itemsList.forEach(items => {
            items.classList.remove("active")
        })
    }

    useEffect(() => {
        getApi()
    }, [])
    return (
        <Fragment>
            <Header />
            <div className='container-fluid mt-5'>
                <div className='col-10 m-auto w__full'>
                    <h3 className='fw-light letra__'>Tienda</h3>
                    <div className='d-flex justify-content-between'>
                        <div className='col-3 me-3 w__full'>
                            <h3 className='fw-light letra__ mt-2 mb-2'>Categoria</h3>
                            <ul className='list-group' id='lista-categorias'>
                                {
                                    productos.map(items => (
                                        <li className='list-group-item fw-bold'
                                            key={items.idcategoria}
                                            style={{ cursor: 'pointer' }}
                                            onClick={(e) => seleccionar(e, items)}>
                                            {items.nombre}
                                            <p className='fw-normal'>{items.descripcion}</p>
                                        </li>
                                    ))
                                }

                            </ul>
                        </div>
                        <div className='col-9 w__full'>
                            <h3 className='fw-light letra__ mt-2 mb-2'>Tu seleccion de producto</h3>
                            <ul className='list-group'>
                                {
                                    categoria.nombre ?
                                        <div className='flex-column'>
                                            <div>
                                                <h4 className='fw-light letra__'>{categoria.nombre}</h4>
                                                <p className='fw-normal'>{categoria.descripcion}</p>
                                                <button className='btn btn-danger text-capitalize'
                                                    onClick={eliminarCategoria}
                                                >Eliminar categoria</button>
                                            </div>

                                            <div className='mt-3'>
                                                <Productos
                                                    categoriaProducto={categoria.idcategoria}
                                                />
                                            </div>
                                        </div>
                                        :
                                        <div>
                                            <p className='fw-normal fw-bold'>Selecciona una categoria</p>
                                        </div>
                                }

                            </ul>
                        </div>
                    </div>

                </div>
            </div>
            <Footer />
        </Fragment>
    )
}

export default Tienda